export const pricingIncludes: string[] = [
  '11 tomos por curso, de 1º de Primaria a 1º de Bachillerato.',
  '330 sesiones base + 330 variantes desarrolladas en toda la colección.',
  'Montajes visuales, tiempos, ajustes y rúbricas de observación.',
  'Hojas imprimibles de apoyo para el profesor.',
  'Los 4 bonos: Mapa Flash de Arranque 7 Días, Kit Visual "Mira y Pita", Scripts de Explicación en 15 Segundos y Panel Anticaos del Profe de EF.',
  'Kit visual en A4 y móvil.'
];
